import Dialog from "@material-ui/core/Dialog/Dialog";

const React = require('react');
const OverlayTrigger = require('react-bootstrap').OverlayTrigger;
const Popover = require('react-bootstrap').Popover;
const Link = require('react-router-dom').Link;
const Avatar = require('./commonControls.jsx').userAvatar;
import FavoriteButton from './favoriteButton.jsx';
const SharedConstants = require('../../../../shared/sharedConstants');
const AjaxFunctions = require('../ajaxFunctions');
const Toastr = require('toastr');
const Utils = require('../utils');
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import TextField from '@material-ui/core/TextField';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import DialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import Button from "@material-ui/core/Button/Button";
import Chip from "@material-ui/core/Chip/Chip";

let tooltipTitle = (title) => {
   return (
      <React.Fragment>
         <div style={{ fontSize: SharedConstants.TooltipValue.FontSize, lineHeight: SharedConstants.TooltipValue.LineHeight }}>
            {title}
         </div>
      </React.Fragment>
   )
};

export class CardContentBodyField extends React.Component{
   constructor(props) {
      super(props);
   }

   getTitle() {
      if(this.props.title){
         return(
            <div className='card-headline-header card-main-container-section-header'>
               {this.props.title}
            </div>
         )
      }
   }

   render() {
      if(this.props.title){
         return(
            <div>
               <div className='card-headline-header card-main-container-section-header'>
                  {this.props.title}
               </div>
               {this.props.data}
            </div>
         )
      }
      else return(
         <div className='card-article-title'>
            {this.props.data}
         </div>
      );
   }
}

export class CardTopics extends React.Component{
   constructor(props) {
      super(props);
   }

   render() {
      const topics = this.props.topicList.map((topic) => {
         return(
            <Chip key={topic.idTopic}  m={2} variant="outlined" color="primary" label={topic.name}/>
         )
      });
      return(
         <div className="tags">
            {topics}
         </div>
      );
   }
}

export class CardTags extends React.Component{
   constructor(props) {
      super(props);
   }

   render() {
      const tags = this.props.tagList.map((tag) => {
         return(
            <Chip key={tag.idTag}  size="small" variant="outlined" color="default" label={tag.text}>
               {tag.text}
            </Chip>
         )
      });
      return(
         
         <div className="tags">
            <br/>
            {tags}
         </div>
      );
   }
}

class PointsDisplay extends React.Component{
   constructor(props) {
      super(props);
   }

   render() {
      if(!this.props.points)
         return (<div />);

      
      return(
         <Tooltip title={tooltipTitle(`This conjecture has earned ${this.props.points} sparks`)}>
            <div>
               <div className={'container-top-bar-points'}>
                  <FontAwesomeIcon icon={['fas',"sparkles"]} size={'1x'} />
                  <span>
                     {this.props.points}
                  </span>
               </div>
            </div>
         </Tooltip>
      );
   }
}

class LaneDisplay extends React.Component{
   constructor(props) {
      super(props);
   }

   render() {
      if(!this.props.lane || this.props.lane === SharedConstants.CardLane.Slow)
         return (<div />);
      else if(this.props.lane === SharedConstants.CardLane.Fast){
         return(
            <div className={'laneDisplayContainer'} title={`This conjecture is earning double sparks!`}>
               <FontAwesomeIcon icon={['fas',"fire"]} size={'1x'} />
            </div>
         );
      }
      else if(this.props.lane === SharedConstants.CardLane.Burst){
         return(
            <div className={'laneDisplayContainer lane-burst'} title={`This conjecture is earning triple sparks!`}>
               <FontAwesomeIcon icon={['fas',"fire"]} size={'1x'} />
            </div>
         );
      }
   }
}

export class CardContentTopRow extends React.Component{
   constructor(props) {
      super(props);
   }

   render() {
      return(
         <div className="author">
            <div className="media">
               {Avatar(this.props.creator)}
               <div className="media-body">
                  <Link to={"/users/profile?idUser=" + this.props.creator.id} className="username">
                     {this.props.creator.firstName} {this.props.creator.lastName} {this.props.creator.points ? `(${this.props.creator.points} points)` : ``}
                  </Link>

                  {
                     this.props.showAdditionalFunctions &&
                     <div className="icon float-right card-content-top-row-icons">
                        <LaneDisplay lane={this.props.card.lane}/>
                        {/* <PointsDisplay points={this.props.card.points}/> */}
                        {/*<i className='fa fa-exclamation-circle' aria-hidden='true' title='Report (Coming Soon)' />*/}
                        <FavoriteButton card={this.props.card}/>
                     </div>
                  }
                  <div className="timestamp">
                     {this.props.creationTime ? new Date(this.props.creationTime).toLocaleDateString() : ''}
                  </div>
               </div>
            </div>
         </div>
      );
   }
}

export class CardCreationInfo extends React.Component{
   constructor(props) {
      super(props);
   }

   render() {
      return(
         <div className="author">
            <div className="media">
               <div className="avatar rounded-circle">
                  {(this.props.creator.lastName) ? this.props.creator.lastName.substring(0,1) : ''}
               </div>
               <div className="media-body">
                  <div className="username">
                     {this.props.creator.firstName} {this.props.creator.lastName}
                  </div>
                  <div className="icon float-right">
                     <i className="material-icons md-18">more_horiz</i>
                  </div>
                  <div className="timestamp">
                     {this.props.creationTime ? new Date(this.props.creationTime).toLocaleDateString() : ''}
                  </div>
               </div>
            </div>
         </div>
      );
   }
}

export class CardCommentButtons extends React.Component{
   constructor(props) {
      super(props);
   }

   render() {
      return(
         <div className='comment-message-buttons'>
            <div className='shape-speach-bubble' onClick={() => alert('Not yet implemented')}>
               Public Message
            </div>
            <div className='shape-speach-bubble' onClick={() => alert('Not yet implemented')}>
               Private Message
            </div>
         </div>
      );
   }
};

export class CardConnections extends React.Component{
   constructor(props) {
      super(props);
   }

   render() {
      if(!this.props.link){
         return null;
      }
      return(
         <div className='connections float'>
            <div className='circle'>{this.props.cards.length}</div>
            <Link to={this.props.link || '/'} >
               <div className='btn'>View Connections</div>
            </Link>
         </div>
      );
   }
}

export class CardSelectorPopover extends React.Component{
   constructor(props) {
      super(props);
      this.state = {
         curTab: 1,
      };
   }

   renderIndividualCard(card){
      return(
         <div className='popover-individual-card'
            key={card[this.props.idCardField]}
            onClick={() => this.props.onSelectionClick(card)}
         >
            <div className='popover-individual-card-header' >
               {card.title}
            </div>
            <div className='popover-individual-card-body' >
               {card.synopsis.substring(0,130) + '. . .'}
            </div>
         </div>
      )
   }

   getAllCards(){
      return this.props.allCards.map((card) => this.renderIndividualCard(card) )
   }

   getRecentCards(){
      return this.props.recentCards.map((card) => this.renderIndividualCard(card) )
   }

   setCurrentTab(tabNumber){
      this.setState({ curTab: tabNumber});
   }

   getCurrentTabDisplay(){
      let curTab = this.state.curTab;
      if(curTab === 1){
         return(this.getAllCards());
      }
      else if(curTab === 2){
         return(2);
      }
      else if(curTab === 3){
         return(this.getRecentCards());
      }
   }

   render() {
      return(
         <div className='card-selection-div'>
            <ul className='nav nav-tabs'>
               <li
                  role="presentation"
                  className={(this.state.curTab === 1) ? 'active' : ''}
                  onClick={() => this.setCurrentTab(1)}
               >
                  <a>Filtered</a>
               </li>
               <li
                  role="presentation"
                  className={(this.state.curTab === 2) ? 'active' : ''}
                  onClick={() => this.setCurrentTab(2)}
               >
                  <a>In Deck</a>
               </li>
               <li
                  role="presentation"
                  className={(this.state.curTab === 3) ? 'active' : ''}
                  onClick={() => this.setCurrentTab(3)}
               >
                  <a>Recent</a>
               </li>
            </ul>
            <div className='popover-card-list'>
               {this.getCurrentTabDisplay()}
            </div>
         </div>
      );
   }
}

export class CardSelector extends React.Component{
   constructor(props) {
      super(props);
   }

   render() {
      const popover = (
         <Popover id='cardSelectorPopover'>
            <CardSelectorPopover
               allCards={this.props.allCards}
               recentCards={this.props.recentCards}
               idCardField={this.props.idCardField}
               onSelectionClick={this.props.onSelectionClick}
            />
         </Popover>
      );
      let isInErrorState = this.props.checkForValidationErrors && !this.props.idCard;
      return(
         <OverlayTrigger trigger="click" rootClose placement="bottom" overlay={popover}>
            <button className={'btn btn-default ' + ( isInErrorState ? 'validation-error' : '')} >
               {this.props.buttonDisplayText}
            </button>
         </OverlayTrigger>
      );
   }
}

export class CardVotes extends React.Component{
   constructor(props) {
      super(props);
   }

   render() {
      let totalVotes = this.props.upVoteCount + this.props.downVoteCount;
      let percentUpVotes = parseInt(100 * this.props.upVoteCount/totalVotes);
      return(
         <div className="card-votes">
            <h4>Quality</h4>
            <h4><small>{totalVotes} votes</small></h4>
            <div className="progress col-sm-8">
               <div className="progress-bar"
                    role="progressbar"
                    aria-valuenow={percentUpVotes}
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style={{width: percentUpVotes + '%'}}>
                  <span className="sr-only">{percentUpVotes}% Positive</span>
               </div>
            </div>
            <div className="col-sm-4 votes">
               <div className="col-sm-4 pull-right vote">
                  <i className="fa fa-thumbs-down" aria-hidden="true" onClick={this.props.downVoteFunction} />
               </div>
               <div className="col-sm-4 pull-right vote">
                  <i className="fa fa-thumbs-up" aria-hidden="true" onClick={this.props.upVoteFunction} />
               </div>
            </div>
         </div>
      );
   }
}